import { LAST_BID_SCOPE_USE } from "../../data/constants";

export const isActivityInPeriod =
  (periodStart, periodEnd, activityStart, activityEnd) =>
    activityStart >= periodStart && activityEnd <= periodEnd;

export const isActivityOutOfPeriod =
  (periodStart, periodEnd, activityStart, activityEnd) =>
    activityEnd <= periodStart || activityStart >= periodEnd;

export const between = (needle, a, b, inclusive = false) => {
  const min = Math.min(a, b);
  const max = Math.max(a, b);

  return inclusive ?
    needle >= min && needle <= max :
    needle > min && needle < max;
};

/**
 * Custom hook to listen for sessionStorage changes for lastBidScopeUsed
 * @param {function} callback - Function to call when the value changes
 * @param {array} dependencies - Optional dependencies array for useEffect
 */
export const useSessionStorageListener = (callback, dependencies = []) => {
  const { useEffect } = require('react');
  
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === LAST_BID_SCOPE_USE) {
        callback();
      }
    };

    const handleCustomEvent = () => {
      callback();
    };

    // Initial call
    callback();

    // Listen for storage events (changes from other tabs/windows)
    window.addEventListener('storage', handleStorageChange);

    // Listen for custom events (changes from same tab)
    window.addEventListener('lastBidScopeUsedChanged', handleCustomEvent);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('lastBidScopeUsedChanged', handleCustomEvent);
    };
  }, dependencies);
};

